import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LoginObject } from 'src/assets/data/interfaces/user.interface';
import { LoginObjectService } from '../services/login-object.service';
import { TokenData } from '../services/oauth2-service';
import { Router } from '@angular/router';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { FontAwesomeService } from '../services/fontawesome.service';


@Component({
  selector: 'app-recupera-contrasenha',
  templateUrl: './recupera-contrasenha.page.html',
  styleUrls: ['./recupera-contrasenha.page.scss'],
})
export class RecuperaContrasenhaPage implements OnInit {
  version;
  siteKey = environment.siteKey;
  isWeb = false;
  // @ViewChild('recaptchaContainer') recaptchaContainer!: ElementRef;
  isRecaptchaCompleted = false;
  recaptchaToken = '';
  estado = 0;
  platform;
  username = '';
  email = '';
  codigo = '';
  error = '';
  newpassword = '';
  newpassword2 = '';
  currentUser: LoginObject = {
    username: '',
    password: '',
    captchaToken: '',
    email: '',
    roles: [],
    userId: undefined,
    clientes: [],
    bloqueado: [],
    mostrarOfertas: null,
    sessionTime: null,
  };

  showExtraLogos: boolean = true;

  loading: boolean = false;

  constructor(
    private tokenData: TokenData,
    private loginObject: LoginObjectService,
    private router: Router,
    private device: Device,
    public faService: FontAwesomeService,
  ) {
    this.version = environment.version
    this.platform = this.device.platform;
  }

  ngOnInit() {
    // if (this.device.platform == null) {
    // The application is running in a browser
    // this.isWeb = true;
    // }
  }


  ngAfterViewInit() {
    // if (this.isWeb == true) {
    // Grecaptcha.render(this.recaptchaContainer.nativeElement, {
    //   sitekey: this.siteKey,
    //   size: 'normal',
    //   callback: this.handleResolved.bind(this)
    // });

    // this.recaptchaContainer.nativeElement.style.marginTop = '20px';
    // this.recaptchaContainer.nativeElement.style.display = 'flex';
    // this.recaptchaContainer.nativeElement.style.justifyContent = 'center';
    // this.recaptchaContainer.nativeElement.style.width = '100%';
    // this.recaptchaContainer.nativeElement.style.height = 'auto';
    // this.recaptchaContainer.nativeElement.style.marginLeft = 'auto';
    // this.recaptchaContainer.nativeElement.style.marginRight = 'auto';

    // }
  }

  // handleResolved(token: string) {
  //   this.recaptchaToken = token;
  //   this.isRecaptchaCompleted = true;
  // }

  validaReset() {
    this.error = '';
    if (!this.username || null == this.username || this.username == '') {
      this.loading = false;
      return this.error = 'Debe introducir su nombre de usuario';
    }

    if (!this.email || null == this.email || this.email == '') {
      this.loading = false;
      return this.error = 'Debe introducir su email';
    }
    // if (!this.isRecaptchaCompleted && this.isWeb == true) {
    //   return this.error = 'No se ha completado el Captcha';
    // }
    if (this.error == '') {
      // this.loading = true; // INICIO DE CARGA A PARTIR DE LA FUNCION validar()
      this.loginObject.setUsername(this.username);
      this.loginObject.setEmail(this.email);
      // if (this.isWeb == true) {
      //   this.loginObject.setCaptchaToken(this.recaptchaToken);
      // }
      this.tokenData.tokenReset(this.loginObject).subscribe({
        next: (data) => {
          if (data != null) {
            localStorage.setItem('tokenreset', data);
            this.tokenData.codigoResetPass().subscribe({
              next: () => { this.loading = false; this.estado = 1; },
              error: (error) => { console.log("Error de recepcion de codigo reset. ", error); this.loading = false; }
            });
          }
          else {
            this.loading = false;
            return this.error = 'Los datos introducidos no son correctos';
          }
        },
        error: (err) => {
          this.loading = false;
          this.username = '';
          this.email = '';
          return this.error = 'Datos de validación incorrectos o usuario ya conectado';
        },
      });
    }

  }

  validaCodigo() {
    this.error = '';
    if (!this.codigo || this.codigo == null || this.codigo == '') {
      this.loading = false;
      return this.error = 'Debe introducir un codigo váido';
    }

    if (this.error == '') {
      // this.loading = true; // INICIO DE CARGA A PARTIR DE LA FUNCION validar()
      this.tokenData.compruebaCodigoPass(this.codigo).subscribe({
        next: () => {
          localStorage.setItem('codigo', this.codigo);
          this.estado = 2;
          this.loading = false;
        },
        error: (err) => { this.loading = false; return this.error = 'Codigo de validación incorrecto'; }
      });
    }

  }

  validaNuevaPassword() {
    this.error = '';
    if (!this.newpassword || null == this.newpassword || this.newpassword == '') {
      this.loading = false;
      return this.error = 'Debe introducir la nueva contraseña';
    }

    if (!this.newpassword2 || null == this.newpassword2 || this.newpassword2 == '') {
      this.loading = false;
      return this.error = 'Debe introducir la confirmación de la nueva contraseña';
    }
    if (this.newpassword != this.newpassword2) {
      this.loading = false;
      return this.error = 'Las contraseñas deben coincidir';
    }
    if (this.error == '') {
      // this.loading = true; // INICIO DE CARGA A PARTIR DE LA FUNCION validar()
      this.tokenData.compruebaContrasenhas(this.newpassword, this.newpassword2).subscribe({
        next: () => {
          this.estado = 0;
          this.router.navigate(['/login'], { replaceUrl: true });
          this.loading = false;
        },
        error: (err) => {
          console.error("Error de comprobacion de contraseñas. ", err);
          this.newpassword = '';
          this.newpassword2 = '';
          this.loading = false;
          return this.error = 'Contraseñas incorrectas';
        }
      });
    }
  }

  logoLoadError(event) {
    this.showExtraLogos = false;
  }

  validar() {
    this.loading = true;
    if (this.estado == 0) { this.validaReset(); }
    if (this.estado == 1) { this.validaCodigo(); }
    if (this.estado == 2) { this.validaNuevaPassword(); }
  }

  backToLogin() {
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }
}